<template>

  <div id="app">

     <yetkidialog ref="yetkidialog"></yetkidialog>

    <v-app id="inspire" light>

      <v-card color="grey lighten-5" flat>

        <v-layout row wrap>

          <v-flex xs12 sm12>

            <v-toolbar size="120px" dark color="info">

              <v-toolbar-title>{{ $t('General-Periodic-Report')}}</v-toolbar-title>

              <v-spacer></v-spacer>

              <v-btn color="pink lighten-1" dark @click="openMailDialog" small>

  <v-icon left>email</v-icon> {{ $t('Send-Mail') }}

</v-btn>

              <v-menu offset-y>

                <v-btn slot="activator" dark icon>

                  <v-icon>more_vert</v-icon>

                </v-btn>

                <v-list>

                  <v-list-tile @click="getListHtml()">

                    <v-list-tile-title>Html {{ $t('Download') }}</v-list-tile-title>

                  </v-list-tile>

                  <v-list-tile @click="getListExcel()">

                    <v-list-tile-title>Excel {{ $t('Download') }}</v-list-tile-title>

                  </v-list-tile>

                </v-list>

              </v-menu>

            </v-toolbar>

          </v-flex>

        </v-layout>

<v-dialog v-model="mailDialog" persistent max-width="640px" scrollable>

  <v-card>

    <v-toolbar dense flat color="info" dark>

      <v-toolbar-title>{{ $t('Send-Mail') }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn icon @click="closeMailDialog"><v-icon>close</v-icon></v-btn>

    </v-toolbar>

    <v-card-text>

      <v-form ref="mailForm" v-model="mailValid" lazy-validation>

        <v-layout wrap>

          <v-flex xs12>

            <v-text-field

              v-model="mailPayload.To"

              :label="$t('Recipient-Email')"

              :rules="[rules.required, rules.email]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.AgencyName"

              :label="$t('Agency-Name')"

              :rules="[rules.required]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.DocType"

              :label="$t('Document-Type')"

              :rules="[rules.required]"

              :disabled="true"

            ></v-text-field>

          </v-flex>

          <v-flex xs12 sm6>

            <v-text-field

              v-model="mailPayload.AgentFullName"

              :label="$t('Agent-Full-Name')"

              :rules="[rules.required]"

              clearable

            ></v-text-field>

          </v-flex>

          <v-flex xs12>

            <v-textarea

              v-model="mailPayload.CustomBody"

              :label="$t('Message')"

              :rules="[rules.required]"

              auto-grow

              rows="3"

            ></v-textarea>

          </v-flex>

        </v-layout>

      </v-form>

    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>

      <v-spacer></v-spacer>

      <v-btn flat @click="closeMailDialog">{{ $t('Cancel') }}</v-btn>

      <v-btn

        color="info"

        :loading="mailLoading"

        :disabled="!mailValid || mailLoading"

        @click="sendMail"

      >

        <v-icon left>send</v-icon>{{ $t('Send') }}

      </v-btn>

    </v-card-actions>

  </v-card>

</v-dialog>

        <v-container fluid="">

          <v-card flat>

            <v-form ref="formgunluksatis" v-model="valid" lazy-validation>

              <v-layout row wrap>

                <v-flex xs12 sm4 md2>

                  <tarihcomp :etiket="$t('Starting-Date')" :detaygizle="false" v-model="Rapor.BaslangicTarih"

                    v-bind:defaultvalue="'ok'" :rules="[v => !!v || $t('Please-select-a-date')]"></tarihcomp>

                </v-flex>

                <v-flex xs12 sm4 md2>

                  <tarihcomp :etiket="$t('Finishing-Date')" :detaygizle="false" v-model="Rapor.BitisTarih"

                    v-bind:defaultvalue="'ok'" :rules="[v => !!v || $t('Please-select-a-date')]"></tarihcomp>

                </v-flex>

                <v-flex xs12 sm4 md3>

                  <havayollaricomp :etiket="$t('Airline-Code')" :rules="[v => !!v || $t('Please-Choose-Airline')]"

                    v-model="havayolubil"></havayollaricomp>

                </v-flex>

                <v-flex>

                  <v-layout>

                    <div v-if="load1">

                      <v-btn color="info" @click="getList()" fab small="" dark>

                        <v-icon>search</v-icon>

                      </v-btn>

                    </div>

                     <div v-if="load1==false">

                            <v-layout fill-height align-center>

                              <v-progress-circular indeterminate :width="4" color="blue"></v-progress-circular>

                            </v-layout>

                          </div>

                    <v-badge color="white" :overlap="true">

                      <template v-slot:badge>

                        <v-icon v-if="filtrevarmi" large color="green">

                          check_circle_outline </v-icon>

                      </template>

                      <v-btn small="" @mouseenter="tooltip = true" @mouseleave="tooltip = false" ref="fab"

                        @click="filtrele()" color="info" fab dark>

                        <v-icon>filter_list</v-icon>

                      </v-btn>

                      <v-tooltip bottom="" :activator="el" v-model="tooltip">

                        <span>{{$t('Add-Search-Filter')}}</span>

                      </v-tooltip>





                    </v-badge>

                  </v-layout>

                </v-flex>

              </v-layout>

            </v-form>

            <v-flex xs12 sm12 md12 pb-3>

              <v-card class="white--text">

                <v-card flat="">

                  <v-card-actions>

                    <v-layout row wrap>

                      <v-flex xs12 sm12 md12>

                        <v-toolbar flat="" size="120px" dark color="#66BB6A">

                          <v-toolbar-title> <span class="subheading white--text">

                             {{ $t('Tickets-Sold') }}

                            </span> </v-toolbar-title>

                          <v-spacer></v-spacer>

                          <v-flex xs6 sm6 md6>

                            <v-text-field flat="" solo-inverted="" hide-details v-model="searchsatilanbilet"

                              :label="$t('Search')" append-icon="search"></v-text-field>

                          </v-flex>

                        </v-toolbar>

                      </v-flex>

<!-- flexxleri buraya -->

                     <v-flex xs12 sm12>

  <v-card flat>

    <!-- ✅ Başlıkları belirginleştir -->
<ReportTable
      :headers="generalSalesHeaders"
      :items="generalSalesItems"
      storage-key="geneldedevreraporu_satis_columns"
      :loading="progress"
      :has-searched="reportHasSearched"
      :show-search="true"
      :search-label="$t('Search')"
      :show-frontend-export="true"
      :export-title="$t('General-Periodic-Report') + ' - ' + $t('Tickets-Sold')"
      :export-meta-items="generalExportMetaItems"
      :export-summary-cards="generalExportSummaryCards"
      :rows-per-page-items="[20, 100, 200, 500, 1000]"
    ></ReportTable>

  </v-card>

</v-flex>

<!-- ====== DESKTOP TOTALS ====== -->

<v-flex

  v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"

  ma-2

  xs12

  sm12

  md12

>

  <v-layout align-center justify-center fill-height>

    <span class="title font-weight-bold total-title">

      {{ $t('General-Totals-Tickets-Sold') }}

    </span>

  </v-layout>

</v-flex>

<v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" xs12 sm12 md12>

  <v-card flat>

    <v-layout>

      <v-flex xs2 sm2 md1>

        <v-layout align-center justify-center fill-height>

          <span class="total-label">{{$t('Number')}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs2 sm2 md2>

        <v-layout align-center justify-center fill-height>

          <span class="total-label">{{$t('Airport-Tax')}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs2 sm2 md2>

        <v-layout align-center justify-center fill-height>

          <span class="total-label">{{$t('Gross')}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs2 sm2 md2>

        <v-layout align-center justify-center fill-height>

          <span class="total-label">{{$t('Penalty')}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs2 sm2 md1>

        <v-layout align-center row justify-center fill-height>

          <span class="total-label">{{$t('Commission')}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs2 sm2 md2>

        <v-layout align-center justify-center fill-height>

          <span class="total-label">{{$t('Service')}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs2 sm2 md1>

        <v-layout align-center justify-center fill-height>

          <span class="total-label">YFF</span>

        </v-layout>

      </v-flex>

      <v-flex xs2 sm2 md2>

        <v-layout align-center justify-center fill-height>

          <span class="total-label">{{$t('Total')}}</span>

        </v-layout>

      </v-flex>

    </v-layout>

    <v-divider light></v-divider>

    <v-layout>

      <v-flex xs2 sm2 md1>

        <v-layout align-center justify-center fill-height>

          <span class="total-value">{{satisGen.Adet}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs1 sm1 md2>

        <v-layout align-center justify-center fill-height>

          <span class="total-value">

            {{satisGen.Alan_Tax | moneyformat}}{{getparabirimi()}}

          </span>

        </v-layout>

      </v-flex>

      <v-flex xs1 sm1 md2>

        <v-layout align-center justify-center fill-height>

          <span class="total-value">

            {{satisGen.Brut | moneyformat}}{{getparabirimi()}}

          </span>

        </v-layout>

      </v-flex>

      <v-flex xs1 sm1 md2>

        <v-layout align-center justify-center fill-height>

          <span class="total-value">

            {{satisGen.Ceza | moneyformat}}{{getparabirimi()}}

          </span>

        </v-layout>

      </v-flex>

      <v-flex xs1 sm1 md1>

        <v-layout align-center row justify-center fill-height>

          <span class="total-value">

            {{satisGen.Komisyon | moneyformat}}{{getparabirimi()}}

          </span>

        </v-layout>

      </v-flex>

      <v-flex xs1 sm1 md2>

        <v-layout align-center justify-center fill-height>

          <span class="total-value">

            {{satisGen.Servis | moneyformat}}{{getparabirimi()}}

          </span>

        </v-layout>

      </v-flex>

      <v-flex xs1 sm1 md1>

        <v-layout align-center justify-center fill-height>

          <span class="total-value">

            {{satisGen.YFF | moneyformat}}{{getparabirimi()}}

          </span>

        </v-layout>

      </v-flex>

      <v-flex xs1 sm1 md2>

        <v-layout align-center justify-center fill-height>

          <span class="total-value">

            {{satisGen.Toplam | moneyformat}}{{getparabirimi()}}

          </span>

        </v-layout>

      </v-flex>

    </v-layout>

  </v-card>

</v-flex>

<!-- ====== MOBILE TOTALS ====== -->

<v-flex v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" xs12 sm12 md12>

  <v-card flat>

    <v-layout row wrap>

      <v-flex xs12>

        <v-layout align-center justify-center fill-height>

          <v-chip color="green">

            <span class="subheading white--text font-weight-bold">{{ $t('Sold-Ticket-Totals') }}</span>

          </v-chip>

        </v-layout>

      </v-flex>

      <v-flex xs12><v-divider light></v-divider></v-flex>

      <v-flex xs12>

        <v-layout align-center justify-center fill-height>

          <span class="mobile-label">{{$t('Number')}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs12>

        <v-layout align-center justify-center fill-height>

          <span class="mobile-value">{{satisGen.Adet}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs12><v-divider light></v-divider></v-flex>

      <v-flex xs12>

        <v-layout align-center justify-center fill-height>

          <span class="mobile-label">{{$t('Airport-Tax')}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs12>

        <v-layout align-center justify-center fill-height>

          <span class="mobile-value">{{satisGen.Alan_Tax | moneyformat}}{{getparabirimi()}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs12><v-divider light></v-divider></v-flex>

      <v-flex xs12>

        <v-layout align-center justify-center fill-height>

          <span class="mobile-label">{{$t('Gross')}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs12>

        <v-layout align-center justify-center fill-height>

          <span class="mobile-value">{{satisGen.Brut | moneyformat}}{{getparabirimi()}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs12><v-divider light></v-divider></v-flex>

      <v-flex xs12>

        <v-layout align-center justify-center fill-height>

          <span class="mobile-label">{{$t('Penalty')}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs12>

        <v-layout align-center justify-center fill-height>

          <span class="mobile-value">{{satisGen.Ceza | moneyformat}}{{getparabirimi()}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs12><v-divider light></v-divider></v-flex>

      <v-flex xs12>

        <v-layout align-center justify-center fill-height>

          <span class="mobile-label">{{$t('Commission')}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs12>

        <v-layout align-center justify-center fill-height>

          <span class="mobile-value">{{satisGen.Komisyon | moneyformat}}{{getparabirimi()}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs12><v-divider light></v-divider></v-flex>

      <v-flex xs12>

        <v-layout align-center justify-center fill-height>

          <span class="mobile-label">{{$t('Service')}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs12>

        <v-layout align-center justify-center fill-height>

          <span class="mobile-value">{{satisGen.Servis | moneyformat}}{{getparabirimi()}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs12><v-divider light></v-divider></v-flex>

      <v-flex xs12>

        <v-layout align-center justify-center fill-height>

          <span class="mobile-label">YFF</span>

        </v-layout>

      </v-flex>

      <v-flex xs12>

        <v-layout align-center justify-center fill-height>

          <span class="mobile-value">{{satisGen.YFF | moneyformat}}{{getparabirimi()}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs12><v-divider light></v-divider></v-flex>

      <v-flex xs12>

        <v-layout align-center justify-center fill-height>

          <span class="mobile-label">{{$t('totalnumber')}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs12>

        <v-layout align-center justify-center fill-height>

          <span class="mobile-value">{{satisGen.Toplam | moneyformat}}{{getparabirimi()}}</span>

        </v-layout>

      </v-flex>

    </v-layout>

  </v-card>

</v-flex>



                    </v-layout>

                  </v-card-actions>

                </v-card>

              </v-card>

            </v-flex>

            <br />

            <v-flex xs12 sm12 md12 pb-3>

              <v-card class="white--text">

                <v-card flat="">

                  <v-card-actions>

                    <v-layout row wrap>

                      <v-flex xs12 sm12 md12>

                        <v-toolbar flat="" size="120px" dark color="red">

                          <v-toolbar-title> <span class="subheading white--text">

                              {{ $t('Refund') }} {{ $t('Ticket') }}

                            </span> </v-toolbar-title>

                          <v-spacer></v-spacer>

                          <v-flex xs6 sm6 md6>

                            <v-text-field flat="" solo-inverted="" hide-details v-model="searchiadebilet" :label="$t('Search')"

                              append-icon="search"></v-text-field>

                          </v-flex>

                        </v-toolbar>

                      </v-flex>

                     <v-flex xs12 sm12>

  <v-card flat>

    <!-- ✅ Başlıkları belirginleştir -->
<ReportTable
      :headers="generalRefundHeaders"
      :items="itemsiade"
      storage-key="geneldedevreraporu_iade_columns"
      :loading="progress"
      :has-searched="reportHasSearched"
      :show-search="true"
      :search-label="$t('Search')"
      :show-frontend-export="true"
      :export-title="$t('General-Periodic-Report') + ' - ' + $t('Refund')"
      :export-meta-items="generalExportMetaItems"
      :export-summary-cards="generalExportSummaryCards"
      :rows-per-page-items="[20, 100, 200, 500, 1000]"
    ></ReportTable>

  </v-card>

</v-flex>

<!-- ====== DESKTOP TOTALS ====== -->

<v-flex

  v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl"

  ma-2

  xs12

  sm12

  md12

>

  <v-layout align-center justify-center fill-height>

    <span class="title font-weight-bold total-title">

      {{$t('Sums-of-Refunded-Tickets')}}

    </span>

  </v-layout>

</v-flex>

<v-flex v-show="$vuetify.breakpoint.md  || $vuetify.breakpoint.lg || $vuetify.breakpoint.xl" xs12 sm12 md12>

  <v-card flat>

    <v-layout>

      <v-flex xs2 sm2 md1>

        <v-layout align-center justify-center fill-height>

          <span class="total-label">{{$t('Number')}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs2 sm2 md2>

        <v-layout align-center justify-center fill-height>

          <span class="total-label">{{$t('Airport-Tax')}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs2 sm2 md2>

        <v-layout align-center justify-center fill-height>

          <span class="total-label">{{$t('Gross')}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs2 sm2 md2>

        <v-layout align-center justify-center fill-height>

          <span class="total-label">{{$t('Penalty')}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs2 sm2 md1>

        <v-layout align-center row justify-center fill-height>

          <span class="total-label">{{$t('Commission')}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs2 sm2 md2>

        <v-layout align-center justify-center fill-height>

          <span class="total-label">{{$t('Service')}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs2 sm2 md1>

        <v-layout align-center justify-center fill-height>

          <span class="total-label">YFF</span>

        </v-layout>

      </v-flex>

      <v-flex xs2 sm2 md2>

        <v-layout align-center justify-center fill-height>

          <span class="total-label">{{$t('Total')}}</span>

        </v-layout>

      </v-flex>

    </v-layout>

    <v-divider light></v-divider>

    <v-layout>

      <v-flex xs2 sm2 md1>

        <v-layout align-center justify-center fill-height>

          <span class="total-value">{{iadeGen.Adet}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs1 sm1 md2>

        <v-layout align-center justify-center fill-height>

          <span class="total-value">{{iadeGen.Alan_Tax | moneyformat}}{{getparabirimi()}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs1 sm1 md2>

        <v-layout align-center justify-center fill-height>

          <span class="total-value">{{iadeGen.Brut | moneyformat}}{{getparabirimi()}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs1 sm1 md2>

        <v-layout align-center justify-center fill-height>

          <span class="total-value">{{iadeGen.Ceza | moneyformat}}{{getparabirimi()}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs1 sm1 md1>

        <v-layout align-center row justify-center fill-height>

          <span class="total-value">{{iadeGen.Komisyon | moneyformat}}{{getparabirimi()}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs1 sm1 md2>

        <v-layout align-center justify-center fill-height>

          <span class="total-value">{{iadeGen.Servis | moneyformat}}{{getparabirimi()}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs1 sm1 md1>

        <v-layout align-center justify-center fill-height>

          <span class="total-value">{{iadeGen.YFF | moneyformat}}{{getparabirimi()}}</span>

        </v-layout>

      </v-flex>

      <v-flex xs1 sm1 md2>

        <v-layout align-center justify-center fill-height>

          <span class="total-value">{{iadeGen.Toplam | moneyformat}}{{getparabirimi()}}</span>

        </v-layout>

      </v-flex>

    </v-layout>

  </v-card>

</v-flex>

<!-- ====== MOBILE TOTALS ====== -->

<v-flex v-show="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm" xs12 sm12 md12>

  <v-card flat>

    <v-layout row wrap>

      <v-flex xs12>

        <v-layout align-center justify-center fill-height>

          <v-chip color="red">

            <span class="subheading white--text font-weight-bold">{{ $t('Sums-of-Refunded-Tickets') }}</span>

          </v-chip>

        </v-layout>

      </v-flex>

      <v-flex xs12><v-divider light></v-divider></v-flex>

      <v-flex xs12><v-layout align-center justify-center fill-height><span class="mobile-label">{{$t('Number')}}</span></v-layout></v-flex>

      <v-flex xs12><v-layout align-center justify-center fill-height><span class="mobile-value">{{iadeGen.Adet}}</span></v-layout></v-flex>

      <v-flex xs12><v-divider light></v-divider></v-flex>

      <v-flex xs12><v-layout align-center justify-center fill-height><span class="mobile-label">{{$t('Airport-Tax')}}</span></v-layout></v-flex>

      <v-flex xs12><v-layout align-center justify-center fill-height><span class="mobile-value">{{iadeGen.Alan_Tax | moneyformat}}{{getparabirimi()}}</span></v-layout></v-flex>

      <v-flex xs12><v-divider light></v-divider></v-flex>

      <v-flex xs12><v-layout align-center justify-center fill-height><span class="mobile-label">{{$t('Gross')}}</span></v-layout></v-flex>

      <v-flex xs12><v-layout align-center justify-center fill-height><span class="mobile-value">{{iadeGen.Brut | moneyformat}}{{getparabirimi()}}</span></v-layout></v-flex>

      <v-flex xs12><v-divider light></v-divider></v-flex>

      <v-flex xs12><v-layout align-center justify-center fill-height><span class="mobile-label">{{$t('Penalty')}}</span></v-layout></v-flex>

      <v-flex xs12><v-layout align-center justify-center fill-height><span class="mobile-value">{{iadeGen.Ceza | moneyformat}}{{getparabirimi()}}</span></v-layout></v-flex>

      <v-flex xs12><v-divider light></v-divider></v-flex>

      <v-flex xs12><v-layout align-center justify-center fill-height><span class="mobile-label">{{$t('Commission')}}</span></v-layout></v-flex>

      <v-flex xs12><v-layout align-center justify-center fill-height><span class="mobile-value">{{iadeGen.Komisyon | moneyformat}}{{getparabirimi()}}</span></v-layout></v-flex>

      <v-flex xs12><v-divider light></v-divider></v-flex>

      <v-flex xs12><v-layout align-center justify-center fill-height><span class="mobile-label">{{$t('Service')}}</span></v-layout></v-flex>

      <v-flex xs12><v-layout align-center justify-center fill-height><span class="mobile-value">{{iadeGen.Servis | moneyformat}}{{getparabirimi()}}</span></v-layout></v-flex>

      <v-flex xs12><v-divider light></v-divider></v-flex>

      <v-flex xs12><v-layout align-center justify-center fill-height><span class="mobile-label">YFF</span></v-layout></v-flex>

      <v-flex xs12><v-layout align-center justify-center fill-height><span class="mobile-value">{{iadeGen.YFF | moneyformat}}{{getparabirimi()}}</span></v-layout></v-flex>

      <v-flex xs12><v-divider light></v-divider></v-flex>

      <v-flex xs12><v-layout align-center justify-center fill-height><span class="mobile-label">{{$t('totalnumber')}}</span></v-layout></v-flex>

      <v-flex xs12><v-layout align-center justify-center fill-height><span class="mobile-value">{{iadeGen.Toplam | moneyformat}}{{getparabirimi()}}</span></v-layout></v-flex>

    </v-layout>

  </v-card>

</v-flex>



                    </v-layout>

                  </v-card-actions>

                </v-card>

              </v-card>

            </v-flex>

          </v-card>

        </v-container>

        <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'"

          :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">

          {{ text1 }}

          <v-btn flat color="pink" @click.native="snackbar = false">{{$t('Close')}}</v-btn>

        </v-snackbar>

        <v-dialog v-model="dialogfiltre" scrollable="" persistent="" max-width="600px">

          <v-card color="grey lighten-5">

            <v-card-title>{{ $t('Filter-selection') }}</v-card-title>

            <v-divider></v-divider>

            <v-card-text>

              <v-card class="white--text">

                <v-card color="grey lighten-5" flat="">

                  <v-card-actions>

                    <v-layout row="" wrap="">

                      <div class="flex md6">

                        <parkurcomp v-model="Rapor.Parkur"></parkurcomp>

                        <v-select hide-details="" :items="doviztipi" v-model="Rapor.DovizTipi" clearable

                          item-text="Title" item-value="DovizKod" :label="$t('Currency-Type')"></v-select>

                      </div>

                      <div v-if="!simpleMode"  class="flex md6">

                        <v-select :items="fiyatturu" v-model="Rapor.FiyatTuru" hide-details="" clearable

                          item-text="text" item-value="value" :label="$t('Price-Type')"></v-select>

                        <v-autocomplete hide-details="" v-model="Rapor.Masraf" :items="masrafmerkezi"

                          :label="$t('Expense-Center-v2')" item-text="CodeName" clearable item-value="Code" max-height="400">

                        </v-autocomplete>

                      </div>

                      <div class="flex xs12">

                        <div class="card__text grey darken-1 white--text">

                          <h3>{{$t('Options')}}</h3>

                        </div>

                      </div>

                      <div class="flex md4">

                        <v-radio-group :label="$t('Ticket-Type')" v-model="Rapor.HatTipi" hide-details>

                          <v-radio :value="0" :label="$t('All')"></v-radio>

                          <v-radio :value="1" :label="$t('Domestic-Line')"></v-radio>

                          <v-radio :value="2" :label="$t('International-Line')"></v-radio>

                          <v-radio :value="3" label="BSP"></v-radio>

                        </v-radio-group>

                      </div>

                      <div v-if="!simpleMode"  class="flex md4">

                        <v-radio-group :label="$t('Payment')" v-model="Rapor.OdemeTipi" hide-details>

                          <v-radio :value="0" :label="$t('All')"></v-radio>

                          <v-radio :value="1" :label="$t('Cash')"></v-radio>

                          <v-radio :value="2" :label="$t('Credit-Card')"></v-radio>

                        </v-radio-group>

                      </div>

                      <div v-if="!simpleMode"  class="flex md4">

                        <v-radio-group :label="$t('Price-Type')" v-model="Rapor.FiyatTipi" hide-details>

                          <v-radio :value="0" :label="$t('Full-Fare-Ticket')"></v-radio>

                          <v-radio :value="1" :label="$t('Ticket-with-VAT')"></v-radio>

                          <v-radio :value="2" :label="$t('Ticket-without-VAT')"></v-radio>

                        </v-radio-group>

                      </div>

                      <div class="flex md6">

                        <v-checkbox v-model="Rapor.Opsiyonlar.ServisDahil" :label="$t('Including-Service-Fee')" hide-details="">

                        </v-checkbox>

                        <v-checkbox :label="$t('Print-Receipts-from-Agency')" v-model="Rapor.Opsiyonlar.AcentaBas"

                          hide-details="">

                        </v-checkbox>

                        <v-checkbox v-model="Rapor.Opsiyonlar.AlisFiyat" :label="$t('Over-Purchase-Price')" hide-details="">

                        </v-checkbox>

                        <v-checkbox v-if="!simpleMode"  :label="$t('Hide-Currency-Ticket-TL-Report')"

                          v-model="Rapor.Opsiyonlar.TLRaporDovizGosterme" hide-details=""></v-checkbox>

                      </div>

                      <div class="flex md6">

                        <v-checkbox v-model="Rapor.Opsiyonlar.BSPGosterme" :label="$t('Dont-Show-BSP-Tickets-Report')"

                          hide-details=""></v-checkbox>

                        <v-checkbox v-if="!simpleMode"  v-model="Rapor.Opsiyonlar.KAVergiAlanaEkle" :label="$t('Add-KA-Tax-to-Space-Tax')"

                          hide-details=""></v-checkbox>

                        <v-checkbox v-model="tumsirketler" :label="$t('All-Companies')" hide-details=""></v-checkbox>

                      </div>

                    </v-layout>

                  </v-card-actions>

                </v-card>

              </v-card>

            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>

              <v-spacer></v-spacer>

              <v-btn color="blue darken-1" flat @click.native="filtreiptal()">{{$t("cancel_button")}}</v-btn>

              <v-btn color="blue darken-1" flat @click.native="filtrekayit()">{{ $t('Apply-Filters') }}</v-btn>

            </v-card-actions>

          </v-card>

        </v-dialog>

      </v-card>

    </v-app>

  </div>

</template>

<script>

  import auth from '../../../../api/auth'

  import tarihcomp from '../../customcomp/tarihim'

  import havayollaricomp from "@/components/app/bilet/partpage/havayollaricomp.vue"

  import parkurcomp from "@/components/app/bilet/partpage/parkurcomp.vue"

   import helpers from "@/components/app/customcomp/helpers.js"

  import yetkidialog from "@/components/app/customcomp/yetkidialog.vue"
  import ReportTable from "@/components/app/customcomp/ReportTable.vue"

  export default {

    data() {

      return {

        simpleMode: false,

        mailDialog: false,

                mailValid: false,

                mailLoading: false,

                mailPayload: {

                  To: "",

                  AgencyName: "",

                  DocType: "", 

                  AgentFullName: "",

                  CustomBody: ""

                },

                rules: {

                  required: v => !!v || this.$t('Required-Field'),

                  email: v => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v) || this.$t('Enter-Valid-Email')

                },

        sayfayetki: {

          Screen: false,

          Update: false,

          Save: false,

          Delete: false,

          Status: false,

          Message: null,

          islem: 0,

        },

        filtrevarmi: false,
        reportHasSearched: false,

        searchsatilanbilet: null,

        searchiadebilet: null,

        itemssatis: [],

        itemsiade: [],

        doviztipi: [],

        havayolubil: {

          havayolukodu: null,

          formno: null

        },

        search: '',

        satisGen: {

          Adet: 0,

          Alan_Tax: 0,

          Brut: 0,

          Ceza: 0,

          Komisyon: 0,

          Servis: 0,

          Toplam: 0,

          YFF: 0

        },

        iadeGen: {

          Adet: 0,

          Alan_Tax: 0,

          Brut: 0,

          Ceza: 0,

          Komisyon: 0,

          Servis: 0,

          Toplam: 0,

          YFF: 0

        },

        Rapor: {

          SirketKodu: null,

          BaslangicTarih: null,

          BitisTarih: null,

          HavaYoluKodu: null,

          Parkur: null,

          FiyatTuru: null,

          DovizTipi: null,

          OdemeTipi: 0, // 0 : hepsi, 1 : peşin, 2 : kredi kart

          HatTipi: 0, // 0 : hepsi, 1 : iç hat, 2 : dış hat, 3 : bsp

          FiyatTipi: 0, // 0 : Hepsi, 1 : kdvsiz, 2 : kdvli

          Masraf: null,

          Opsiyonlar: {

            ServisDahil: false,

            AcentaBas: false,

            AlisFiyat: false,

            BSPGosterme: false,

            TLRaporDovizGosterme: false,

            KAVergiAlanaEkle: false,

          }

        },

        itemsairlinelist: [],

        hesapgurubu: [],

        masrafmerkezi: [],

        valid: true,

        tumsirketler: '',

        totalCount: 0,

        totalService: 0,

        totalAmount: 0,

        StartDate: null,

        EndDate: null,

        date: null,

        menu: false,

        modal: false,

        dateFormatted: '',

        date2: null,

        menu2: false,

        dateFormatted2: '',

        modal2: false,

        loading: false,

        items: [],

        load: false,

        load1: true,

        search3: '',

        renk1: 'info',

        dialogfiltre: false,

        hesapkodu: [],

        kredikarti: [],

        statecari: [],

        searchcari: '',

        progress: false,

        tooltip: false,

        el: null,

        yok: false,

        itemsvoid: [],

        butondurum: true,

        snackbar: false,

        y: 'top',

        x: 'right',

        mode: '',

        timeout: 6000,

        text1: '',

        dictionary: {

          custom: {

            tarihsec: {

              required: () => this.$t('Please-select-a-date')

            },

            tarihsec1: {

              required: () => this.$t('Please-select-a-date')

            },

          }

        },

      }

    },

     beforeRouteEnter(to, from, next) {

      next(vm => {

        vm.prevRoute = from.path

      })

    },

    beforeMount: beforeMount,

    mounted() {

      this.simpleModeYukle();

      this.simpleModeDefaultlariUygula();

      this.$validator.localize('en', this.dictionary)

      this.el = this.$refs.fab.$el

       this.sayfayetki = helpers.pageScreenAuth(this.$route.name)

      if (this.sayfayetki.Status != true) {

        this.$refs.yetkidialog.open(this.sayfayetki.Message, this.sayfayetki.islem).then(sonuc => {

          if (sonuc == true) {

            if (this.prevRoute != null) {

              var url = '#' + this.prevRoute

              window.open(url, '_self')

            } else {

              var mainUrl = '#/'

              window.open(mainUrl, '_self')

            }

          } 

        });

      } 

    },

    filters: {

      dateformat: function (t) {

        return helpers.dateformat(t);

      },

      moneyformat: function (m) {

        return helpers.moneyformat(m);

      },

      bakiyekontrol: function (m) {

        return helpers.bakiyekontrol(m);

      }

    },

    components: {

      'tarihcomp': tarihcomp,

      havayollaricomp,

      parkurcomp,

      yetkidialog,
      ReportTable

    },

    watch: {

      searchcari(val) {

        val && this.carigetir(val)

      }

    },

    methods: {

      simpleModeYukle() {

  var manageload = null;

  try {

    manageload = JSON.parse(window.localStorage.getItem('WebUserManageLoad'));

  } catch (e) {

    manageload = null;

  }

  if (manageload && manageload.UserInfo) {

    this.simpleMode =

      manageload.UserInfo.SimpleMode === true ||

      manageload.UserInfo.SimpleMode === 1 ||

      manageload.UserInfo.SimpleMode === "1" ||

      manageload.UserInfo.SimpleMode === "true";

  }

},

simpleModeDefaultlariUygula() {

  if (!this.simpleMode) {

    return;

  }

  this.Rapor.FiyatTuru = null;

  this.Rapor.Masraf = null;

  this.Rapor.OdemeTipi = 0;

  this.Rapor.FiyatTipi = 0;

  if (this.Rapor.Opsiyonlar) {

    this.Rapor.Opsiyonlar.TLRaporDovizGosterme = false;

    this.Rapor.Opsiyonlar.KAVergiAlanaEkle = false;

  }

},

  openMailDialog: function () {

    var pageDocType = this.$t('General-Periodic-Report');

    if (!this.mailPayload) this.mailPayload = {};

    this.mailPayload.DocType = pageDocType;

    if (this.$refs && this.$refs.mailForm && this.$refs.mailForm.resetValidation) {

      this.$refs.mailForm.resetValidation();

    }

    this.mailDialog = true;

  },

  closeMailDialog: function () {

    this.mailDialog = false;

  },

  sendMail: function () {

    var _this = this;

    if (!(_this.$refs && _this.$refs.mailForm && _this.$refs.mailForm.validate && _this.$refs.mailForm.validate())) {

      return;

    }

    var bas = (_this.Rapor && _this.Rapor.BaslangicTarih) ? new Date(_this.Rapor.BaslangicTarih) : null;

    var bit = (_this.Rapor && _this.Rapor.BitisTarih) ? new Date(_this.Rapor.BitisTarih) : null;

    if (!(bas && bit && bas <= bit)) {

      _this.text1 = _this.$t('start-date-cannot-greater-than-end-date');

      _this.snackbar = true;

      return;

    }

    var havayoluKod = (_this.havayolubil && _this.havayolubil.havayolukodu) ? _this.havayolubil.havayolukodu : null;

    if (!havayoluKod) {

      _this.text1 = _this.$t('Please-Choose-Airline');

      _this.snackbar = true;

      return;

    }

    var credentialsRaw = window.localStorage.getItem('credentials');

    var credentials = credentialsRaw ? JSON.parse(credentialsRaw) : {};

    var companyCode = (_this.tumsirketler === true)

      ? 0

      : (credentials && credentials.SirketKodu) ? credentials.SirketKodu : null;

    var R = _this.Rapor || {};

    var inputObj = {

      SirketKodu: companyCode,

      BaslangicTarih: R.BaslangicTarih || null,

      BitisTarih: R.BitisTarih || null,

      HavaYoluKodu: havayoluKod,

      Parkur: R.Parkur || null,

      FiyatTuru: R.FiyatTuru || null,

      DovizTipi: R.DovizTipi || null,

      OdemeTipi: (typeof R.OdemeTipi !== 'undefined') ? R.OdemeTipi : 0,          

      HatTipi: (typeof R.HatTipi !== 'undefined') ? R.HatTipi : 0,            

      FiyatTipi: (typeof R.FiyatTipi !== 'undefined') ? R.FiyatTipi : 0,           

      Masraf: R.Masraf || null,

      Opsiyonlar: {

        ServisDahil: R.Opsiyonlar && typeof R.Opsiyonlar.ServisDahil !== 'undefined' ? R.Opsiyonlar.ServisDahil : false,

        AcentaBas: R.Opsiyonlar && typeof R.Opsiyonlar.AcentaBas !== 'undefined' ? R.Opsiyonlar.AcentaBas : false,

        AlisFiyat: R.Opsiyonlar && typeof R.Opsiyonlar.AlisFiyat !== 'undefined' ? R.Opsiyonlar.AlisFiyat : false,

        BSPGosterme: R.Opsiyonlar && typeof R.Opsiyonlar.BSPGosterme !== 'undefined' ? R.Opsiyonlar.BSPGosterme : false,

        TLRaporDovizGosterme: R.Opsiyonlar && typeof R.Opsiyonlar.TLRaporDovizGosterme !== 'undefined' ? R.Opsiyonlar.TLRaporDovizGosterme : false,

        KAVergiAlanaEkle: R.Opsiyonlar && typeof R.Opsiyonlar.KAVergiAlanaEkle !== 'undefined' ? R.Opsiyonlar.KAVergiAlanaEkle : false

      }

    };

    var pageDocType = _this.$t('General-Periodic-Report');

    var mailObj = {

      To: (_this.mailPayload && _this.mailPayload.To) ? _this.mailPayload.To : "",

      AgencyName: (_this.mailPayload && _this.mailPayload.AgencyName) ? _this.mailPayload.AgencyName : "",

      DocType: (_this.mailPayload && _this.mailPayload.DocType) ? _this.mailPayload.DocType : pageDocType,

      AgentFullName: (_this.mailPayload && _this.mailPayload.AgentFullName) ? _this.mailPayload.AgentFullName : "",

      CustomBody: (_this.mailPayload && _this.mailPayload.CustomBody) ? _this.mailPayload.CustomBody : ""

    };

    var payload = { Input: inputObj, Mail: mailObj };

    _this.mailLoading = true;

    var endpoint = auth.API_URL + 'api/TicketPeriodReport/MailGonderGenelDevreRaporuExcel';

    _this.$http.post(

      endpoint,

      payload,

      { headers: { 'Authorization': 'Bearer ' + auth.getAuthHeader() } }

    ).then(function () {

      _this.mailLoading = false;

      _this.mailDialog = false;

      _this.text1 = _this.$t('Mail-Sent');

      _this.snackbar = true;

    }, function (err) {

      _this.mailLoading = false;

      var body = (err && (err.body || err.data)) ? (err.body || err.data) : {};

      var msg = (body && (body.Message || body.message)) || err.statusText || _this.$t('Mail-Could-Not-Be-Sent');

      _this.text1 = msg;

      _this.snackbar = true;

    });

  },



          getparabirimi() {

        return helpers.getparabirimi()

      },

      getList: getList,

      getListHtml: getListHtml,

      getListExcel: getListExcel,

      filtrele: filtrele,

      filtrekayit: filtrekayit,

      filtreiptal: filtreiptal,

    },

    computed:{

      generalSalesHeaders() {
        var money=['Brut','Komisyon','YFF','Ceza','Alan_Tax','Toplam'];
        return (this.headerssatis||[]).map(function(header){
          var h=Object.assign({},header);
          if(h.value==='FaturaNo') h.value='_FaturaNo';
          h.type=money.indexOf(h.value)!==-1?'money':((h.value==='UcusTarihi'||h.value==='SatisTarihi')?'date':'text');
          h.visible=true; h.sortable=true; return h;
        });
      },
      generalSalesItems() {
        return (this.itemssatis||[]).map(function(item){
          var row=Object.assign({},item);
          row._FaturaNo=item&&item.OnayFaturaNo?item.OnayFaturaNo:(item?item.FaturaNo:'');
          return row;
        });
      },
      generalRefundHeaders() {
        var money=['Brut','Komisyon','YFF','Ceza','Alan_Tax','Toplam'];
        return (this.headerssatisiade||[]).map(function(header){
          var h=Object.assign({},header);
          h.type=money.indexOf(h.value)!==-1?'money':((h.value==='UcusTarihi'||h.value==='SatisTarihi')?'date':'text');
          h.visible=true; h.sortable=true; return h;
        });
      },
      generalExportMetaItems() {
        var ticketTypes=[this.$t('All'),this.$t('Domestic-Line'),this.$t('International-Line'),'BSP'];
        var paymentTypes=[this.$t('All'),this.$t('Cash'),this.$t('Credit-Card')];
        var priceTypes=[this.$t('Full-Fare-Ticket'),this.$t('Ticket-with-VAT'),this.$t('Ticket-without-VAT')];
        return [
          {label:this.$t('Starting-Date'),value:this.Rapor.BaslangicTarih,type:'date'},
          {label:this.$t('Finishing-Date'),value:this.Rapor.BitisTarih,type:'date'},
          {label:this.$t('Airline-Code'),value:this.havayolubil&&this.havayolubil.havayolukodu?this.havayolubil.havayolukodu:''},
          {label:this.$t('Route'),value:this.Rapor.Parkur||''},
          {label:this.$t('Currency-Type'),value:this.Rapor.DovizTipi||''},
          {label:this.$t('Price-Type'),value:this.Rapor.FiyatTuru||''},
          {label:this.$t('Expense-Center-v2'),value:this.Rapor.Masraf||''},
          {label:this.$t('Ticket-Type'),value:ticketTypes[this.Rapor.HatTipi]||''},
          {label:this.$t('Payment'),value:paymentTypes[this.Rapor.OdemeTipi]||''},
          {label:this.$t('Price-Type'),value:priceTypes[this.Rapor.FiyatTipi]||''},
          {label:this.$t('Including-Service-Fee'),value:this.Rapor.Opsiyonlar&&this.Rapor.Opsiyonlar.ServisDahil?this.$t('Yes'):this.$t('No')},
          {label:this.$t('Print-Receipts-from-Agency'),value:this.Rapor.Opsiyonlar&&this.Rapor.Opsiyonlar.AcentaBas?this.$t('Yes'):this.$t('No')},
          {label:this.$t('Over-Purchase-Price'),value:this.Rapor.Opsiyonlar&&this.Rapor.Opsiyonlar.AlisFiyat?this.$t('Yes'):this.$t('No')},
          {label:this.$t('Dont-Show-BSP-Tickets-Report'),value:this.Rapor.Opsiyonlar&&this.Rapor.Opsiyonlar.BSPGosterme?this.$t('Yes'):this.$t('No')},
          {label:this.$t('All-Companies'),value:this.tumsirketler===true?this.$t('Yes'):this.$t('No')}
        ];
      },
      generalExportSummaryCards() {
        var s=this.satisGen||{},i=this.iadeGen||{};
        return [
          {title:this.$t('General-Totals-Tickets-Sold'),items:[
            {label:this.$t('Number'),value:s.Adet||0,type:'number'},{label:this.$t('Airport-Tax'),value:s.Alan_Tax||0,type:'money'},
            {label:this.$t('Gross'),value:s.Brut||0,type:'money'},{label:this.$t('Penalty'),value:s.Ceza||0,type:'money'},
            {label:this.$t('Commission'),value:s.Komisyon||0,type:'money'},{label:this.$t('Service'),value:s.Servis||0,type:'money'},
            {label:'YFF',value:s.YFF||0,type:'money'},{label:this.$t('Total'),value:s.Toplam||0,type:'money'}]},
          {title:this.$t('Sums-of-Refunded-Tickets'),items:[
            {label:this.$t('Number'),value:i.Adet||0,type:'number'},{label:this.$t('Airport-Tax'),value:i.Alan_Tax||0,type:'money'},
            {label:this.$t('Gross'),value:i.Brut||0,type:'money'},{label:this.$t('Penalty'),value:i.Ceza||0,type:'money'},
            {label:this.$t('Commission'),value:i.Komisyon||0,type:'money'},{label:this.$t('Service'),value:i.Servis||0,type:'money'},
            {label:'YFF',value:i.YFF||0,type:'money'},{label:this.$t('Total'),value:i.Toplam||0,type:'money'}]}
        ];
      },


          headerssatis(){

          return [{

            text: this.$t('Ticket-No'),

            value: 'BiletNo',

            width: "10%",

            align: 'left'

          },

          {

            text: this.$t('Name-of-Passenger'),

            value: 'YolcuAdi',

            width: "10%",

            align: 'left'

          },

          {

            text: this.$t('Flight-Date'),

            value: 'UcusTarihi',

            width: "10%",

            align: 'left'

          },

          {

            text: this.$t('Sales-Date'),

            value: 'SatisTarihi',

            width: "10%",

            align: 'left'

          },

          {

            text: 'ACI',

            value: 'ACI',

            width: "10%",

            align: 'left'

          },

          {

            text: 'Pax',

            value: 'Pax',

            width: "10%",

            align: 'left'

          },

          {

            text: this.$t('Line-Type'),

            value: 'HatTipi',

            width: "1%",

            align: 'left'

          },

          {

            text: this.$t('Route'),

            value: 'Parkurlar',

            width: "10%",

            align: 'left'

          },{

            text: this.$t('Current'),

            value: 'CariKod',

            width: "10%",

            align: 'left'

          },{

            text: this.$t('Expense-Center-v2'),

            value: 'MasrafMerkeziKodu',

            width: "10%",

            align: 'left'

          },{

            text: this.$t('Expense-Centre-Name'),

            value: 'MasrafMerkeziAdi',

            width: "10%",

            align: 'left'

          },{

            text: this.$t('Invoice-No'),

            value: 'FaturaNo',

            width: "10%",

            align: 'center'

          },

          {

            text: this.$t('Gross'),

            value: 'Brut',

            width: "10%",

            align: 'left'

          },

          {

            text: this.$t('Commission'),

            value: 'Komisyon',

            width: "10%",

            align: 'left'

          },

          {

            text: 'YFF',

            value: 'YFF',

            width: "10%",

            align: 'left'

          },

          {

            text: this.$t('Penalty'),

            value: 'Ceza',

            width: "10%",

            align: 'left'

          },

          {

            text: this.$t('Airport-Tax'),

            value: 'Alan_Tax',

            width: "10%",

            align: 'left'

          },

          {

            text: this.$t('Total'),

            value: 'Toplam',

            width: "0%",

            align: 'left'

          },

        ]

        },

        headerssatisiade(){

          return [{

            text: this.$t('Ticket-No'),

            value: 'BiletNo',

            width: "10%",

            align: 'left'

          },

          {

            text: this.$t('Name-of-Passenger'),

            value: 'YolcuAdi',

            width: "10%",

            align: 'left'

          },

          {

            text: this.$t('Flight-Date'),

            value: 'UcusTarihi',

            width: "10%",

            align: 'left'

          },

          {

            text: this.$t('Sales-Date'),

            value: 'SatisTarihi',

            width: "10%",

            align: 'left'

          },

          {

            text: 'ACI',

            value: 'ACI',

            width: "10%",

            align: 'left'

          },

          {

            text: 'Pax',

            value: 'Pax',

            width: "10%",

            align: 'left'

          },

          {

            text: this.$t('Line-Type'),

            value: 'HatTipi',

            width: "1%",

            align: 'left'

          },

          {

            text: this.$t('Route'),

            value: 'Parkurlar',

            width: "10%",

            align: 'left'

          },{

            text: this.$t('Current'),

            value: 'CariKod',

            width: "10%",

            align: 'left'

          },{

            text: this.$t('Receipt-No'),

            value: 'FaturaNo',

            width: "10%",

            align: 'center'

          },

          {

            text: this.$t('Gross'),

            value: 'Brut',

            width: "10%",

            align: 'left'

          },

          {

            text: this.$t('Commission'),

            value: 'Komisyon',

            width: "10%",

            align: 'left'

          },

          {

            text: 'YFF',

            value: 'YFF',

            width: "10%",

            align: 'left'

          },

          {

            text: this.$t('Penalty'),

            value: 'Ceza',

            width: "10%",

            align: 'left'

          },

          {

            text: this.$t('Airport-Tax'),

            value: 'Alan_Tax',

            width: "10%",

            align: 'left'

          },

          {

            text: this.$t('Total'),

            value: 'Toplam',

            width: "0%",

            align: 'left'

          },

        ]

        },



        fiyatturu(){

          return[{

            text: 'AD-' + this.$t('Adult'),

            value: 'AD'

          },

          {

            text: 'CHD-' + this.$t('Child'),

            value: 'CHD'

          },

          {

            text: 'INF-' + this.$t('Baby'),

            value: 'INF'

          },

          {

            text: 'TUS-' + this.$t('Diplomatic'),

            value: 'TUS'

          },

          {

            text: 'EX',

            value: 'EX'

          },

          {

            text: 'STD-' + this.$t('Student'),

            value: 'STD'

          },

          {

            text: 'SRC-' + this.$t('Elderly'),

            value: 'SRC'

          },

          {

            text: 'MIL-' + this.$t('Soldier'),

            value: 'MIL'

          },

          {

            text: 'YTH-' + this.$t('Young'),

            value: 'YTH'

          }

        ]

        },

          headerssatis542(){

            return [{

            text: 'HY',

            value: 'HavayoluKodu'

          },

          {

            text: this.$t('Ticket-No'),

            value: 'BiletNo'

          },

          {

            text: this.$t('Flight-Type'),

            value: 'UcusTip'

          },

          {

            text: 'Hesap',

            value: 'Cari.Kod'

          },

          {

            text: this.$t('Ticket-Amount'),

            value: 'BiletTutari'

          },

          {

            text: this.$t('Tax-v2'),

            value: 'VergiTutari'

          },

          {

            text: 'Iskonto',

            value: 'IskontoTutari'

          },

          {

            text: this.$t('Service'),

            value: 'ServisTutari'

          },

          {

            text: this.$t('Reserve') ,

            value: 'ReserveTutari'

          },

          {

            text: this.$t('With-Credit'),

            value: 'KrediliTutar'

          },

          {

            text: this.$t('Cash'),

            value: 'PesinTutar'

          },

          {

            text: this.$t('With-Credit-Card'),

            value: 'KrediKartTutar'

          },

          {

            text: this.$t('Credit-Card-No'),

            value: 'KrediKartNo'

          },

          {

            text: this.$t('Invoice-No'),

            value: 'FaturaNo'

          },

          {

            text: this.$t('Penalty'),

            value: 'CezaTutari'

          }

        ]

        },

        headervoid(){

          return [{

            text: 'HY',

            value: 'HavayoluKodu'

          },

          {

            text: this.$t('Ticket-No'),

            value: 'BiletNo'

          },

          {

            text: this.$t('Flight-Type'),

            value: 'UcusTip'

          },

          {

            text: this.$t('Description'),

            value: ''

          }

        ]

        },

    }

  }

  function filtrele() {

    this.simpleModeYukle();

  this.simpleModeDefaultlariUygula();

    this.dialogfiltre = true

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params = {

      CompanyCode: credentials.SirketKodu

    }

    this.$http.post(auth.API_URL + 'api/currency/List', params, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      }

    }).then((response) => {

      this.doviztipi = response.body

    }, (response) => {

      if (response.status === 0) {

        this.text1 = this.$t('Service-Unavailable')

        this.snackbar = true

      } else {

        this.text1 = this.$t('Service-Unavailable')

        this.snackbar = true

      }

    })

    this.$http.post(auth.API_URL + 'api/ExpenseCenter/List', params, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      }

    }).then((response) => {

      this.masrafmerkezi = response.body

    }, (response) => {

      if (response.status === 0) {

        this.text1 = this.$t('Service-Unavailable')

        this.snackbar = true

      } else {

        this.text1 = this.$t('Service-Unavailable')

        this.snackbar = true

      }

    })

  }

  function filtrekayit() {

    this.filtrevarmi = true

    this.getList();

    this.dialogfiltre = false

  }

  function filtreiptal() {

    this.filtrevarmi = false

    this.dialogfiltre = false

    this.Rapor.SirketKodu = null

    this.Rapor.Parkur = null

    this.Rapor.FiyatTuru = null

    this.Rapor.DovizTipi = null

    this.Rapor.OdemeTipi = 0 // 0 : hepsi, 1 : peşin, 2 : kredi kart

    this.Rapor.HatTipi = 0 // 0 : hepsi, 1 : iç hat, 2 : dış hat, 3 : bsp

    this.Rapor.FiyatTipi = 0 // 0 : Hepsi, 1 : kdvsiz, 2 : kdvli

    this.Rapor.Masraf = null

    this.Rapor.Opsiyonlar.ServisDahil = false

    this.Rapor.Opsiyonlar.AcentaBas = false

    this.Rapor.Opsiyonlar.AlisFiyat = false

    this.Rapor.Opsiyonlar.BSPGosterme = false

    this.Rapor.Opsiyonlar.TLRaporDovizGosterme = false

    this.Rapor.Opsiyonlar.KAVergiAlanaEkle = false

  }

  function getList() {
    this.reportHasSearched = true;

    this.simpleModeYukle();

  this.simpleModeDefaultlariUygula();

    if (this.$refs.formgunluksatis.validate()) {

      if (this.havayolubil.havayolukodu != null) {

        this.progress = true

        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {

          this.Rapor.SirketKodu = '0'

        } else {

          this.Rapor.SirketKodu = credentials.SirketKodu

        }

        this.Rapor.HavaYoluKodu = this.havayolubil.havayolukodu

        var params = this.Rapor

        this.$http.post(auth.API_URL + 'api/TicketPeriodReport/GeneralPeriodReport', params, {

          headers: {

            'Authorization': 'Bearer ' + auth.getAuthHeader()

          }

        }).then((response) => {

          this.itemssatis = response.body.SatisBilgi.SatisBiletListe

          this.itemsiade = response.body.IadeBilgi.IadeBiletListe

          this.satisGen = response.body.SatisBilgi.SatisToplamlar

          this.iadeGen = response.body.IadeBilgi.IadeToplamlar

          this.progress = false

          this.load1 = true

        }, (response) => {

          if (response.status === 0) {

            this.text1 = this.$t('Service-Unavailable')

            this.snackbar = true

            this.progress = false

            this.load1 = true

          } else {

            this.text1 = this.$t('Service-Unavailable')

            this.snackbar = true

            this.progress = false

            this.load1 = true

          }

        })

      } else {

        this.text1 = this.$t('Please-Select-Airline-Code')

        this.snackbar = true

      }

    }

  }

  function getListHtml() {

    if (this.$refs.formgunluksatis.validate()) {

      if (this.havayolubil.havayolukodu != null) {

        this.progress = true

        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        var lang = localStorage.getItem('lang')

        if (this.tumsirketler === true) {

          this.Rapor.SirketKodu = '0'

        } else {

          this.Rapor.SirketKodu = credentials.SirketKodu

        }

        this.Rapor.HavaYoluKodu = this.havayolubil.havayolukodu

        var params = this.Rapor

        this.$http

          .post(auth.API_URL + "api/TicketPeriodReport/GeneralPeriodReportHtml", params, {

            headers: {

              Authorization: "Bearer " + auth.getAuthHeader()

            }

          }).then((response) => {

            this.progress = false

            this.load1 = true

            if (lang=='en')

          {

            var bodyhtml=helpers.getTranslatedHtml(response.bodyText);

             bodyhtml=bodyhtml.toString().replace('<title> BORÇLU ALACAKLI LİSTESİ </title>','<title> DEBTOR CREDITOR LIST </title>');

             bodyhtml=bodyhtml.toString().replace("<font face = 'Arial' size = '4' color = '#FFFFF0'>BORÇLU ALACAKLI LİSTESİ</font>","<font face = 'Arial' size = '4' color = '#FFFFF0'>DEBTOR CREDITOR LIST</font>")



             response.bodyText=bodyhtml;

          }

            var blob = new Blob([response.bodyText], {

              type: 'application/html'

            });

            var link = document.createElement('a');

            link.href = window.URL.createObjectURL(blob);

            link.download = "GenelDevre.html";

            link.click();

          }, (response) => {

            if (response.status === 0) {

              this.text1 = this.$t('Service-Unavailable')

              this.snackbar = true

              this.progress = false

              this.load1 = true

            } else {

              this.text1 = this.$t('Service-Unavailable')

              this.snackbar = true

              this.progress = false

              this.load1 = true

            }

          })

      } else {

        this.text1 = this.$t('Please-Select-Airline-Code')

        this.snackbar = true

      }

    }

  }

  function getListExcel() {

    if (this.$refs.formgunluksatis.validate()) {

      if (this.havayolubil.havayolukodu != null) {

        this.progress = true

        this.load1 = false

        var credentials = JSON.parse(window.localStorage.getItem('credentials'));

        if (this.tumsirketler === true) {

          this.Rapor.SirketKodu = '0'

        } else {

          this.Rapor.SirketKodu = credentials.SirketKodu

        }

        this.Rapor.HavaYoluKodu = this.havayolubil.havayolukodu

        var params = this.Rapor

        this.$http

          .post(auth.API_URL + "api/TicketPeriodReport/GeneralPeriodReportExcel", params, {

            headers: {

              Authorization: "Bearer " + auth.getAuthHeader()

            },

            responseType: "arraybuffer"

          }).then((response) => {

            this.progress = false

            this.load1 = true

            var blob = new Blob([response.data], {

              type: 'application/xlsx'

            });

            var link = document.createElement('a');

            link.href = window.URL.createObjectURL(blob);

            link.download = "GenelDevre.xlsx";

            link.click();

          }, (response) => {

            if (response.status === 0) {

              this.text1 = this.$t('Service-Unavailable')

              this.snackbar = true

              this.progress = false

              this.load1 = true

            } else {

              this.text1 = this.$t('Service-Unavailable')

              this.snackbar = true

              this.progress = false

              this.load1 = true

            }

          })

      } else {

        this.text1 = this.$t('Please-Select-Airline-Code')

        this.snackbar = true

      }

    }

  }

  function beforeMount() {

    var credentials = JSON.parse(window.localStorage.getItem('credentials'));

    var params1 = {

      CompanyCode: credentials.SirketKodu

    }

    this.$http.post(auth.API_URL + 'api/currency/List', params1, {

      headers: {

        'Authorization': 'Bearer ' + auth.getAuthHeader()

      }

    }).then((response) => {

      this.doviztipi = response.body

    }, (response) => {

      if (response.status === 0) {

        this.text1 = this.$t('Service-Unavailable')

        this.snackbar = true

      } else {

        this.text1 = this.$t('Service-Unavailable')

        this.snackbar = true

      }

    })

  }

</script>

<style scoped>

  /* ===== IADE TABLE ===== */

.iade-table table thead th {

  background: #ECEFF1;

}

.iade-header {

  font-size: 14px;

  font-weight: 700;

  color: #263238;

  letter-spacing: .3px;

  text-transform: uppercase;

  padding-top: 10px;

  padding-bottom: 10px;

}

.iade-cell {

  font-size: 14px;

  font-weight: 500;

  color: #37474F;

}

.iade-money {

  font-weight: 700;

  color: #0D47A1;

}

.iade-table tbody tr:hover {

  background-color: #F5F7FA;

}

.iade-table td {

  border-bottom: 1px solid #E0E0E0;

}

/* ===== TOTALS (DESKTOP + MOBILE) ===== */

/* Bunlar önceki blokta da varsa tekrar yazmana gerek yok */

.total-title {

  color: #1A237E;

}

.total-label {

  font-size: 14px;

  font-weight: 700;

  color: #263238;

}

.total-value {

  font-size: 15px;

  font-weight: 700;

  color: #0D47A1;

}

.mobile-label {

  font-size: 14px;

  font-weight: 700;

  color: #263238;

}

.mobile-value {

  font-size: 16px;

  font-weight: 800;

  color: #1B5E20;

}

  /* ===== TABLE ===== */

.satis-table table thead th {

  background: #ECEFF1;

}

.satis-header {

  font-size: 14px;     /* 12px yok */

  font-weight: 700;

  color: #263238;

  letter-spacing: .3px;

  text-transform: uppercase;

  padding-top: 10px;

  padding-bottom: 10px;

}

.satis-cell {

  font-size: 14px;

  font-weight: 500;

  color: #37474F;

}

.satis-money {

  font-weight: 700;

  color: #0D47A1;

}

.satis-table tbody tr:hover {

  background-color: #F5F7FA;

}

.satis-table td {

  border-bottom: 1px solid #E0E0E0;

}

/* ===== TOTALS (DESKTOP) ===== */

.total-title {

  color: #1A237E;

}

.total-label {

  font-size: 14px;

  font-weight: 700;

  color: #263238;

}

.total-value {

  font-size: 15px;

  font-weight: 700;

  color: #0D47A1;

}

/* ===== TOTALS (MOBILE) ===== */

.mobile-label {

  font-size: 14px;

  font-weight: 700;

  color: #263238;

}

.mobile-value {

  font-size: 16px;

  font-weight: 800;

  color: #1B5E20;

}

</style>